import tailwindConfig from 'src/../tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'
import { TailwindColorConfig } from 'tailwindcss/tailwind-config'

const themeColors = resolveConfig(tailwindConfig).theme
  .colors as TailwindColorConfig & { [key: string]: string }

export default themeColors
